import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';

interface Recipe {
  id: number;
  name: string;
  ingredients: string[];
  instructions: string[];
}

const RecipeDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [recipe, setRecipe] = useState<Recipe | null>(null);

  useEffect(() => {
    if (id) {
      axios.get(`http://localhost:8000/api/recipes`)
        .then(response => {
          const foundRecipe = response.data.find((r: any) => r.id === parseInt(id));
          if (foundRecipe) {
            setRecipe({
              ...foundRecipe,
              ingredients: JSON.parse(foundRecipe.ingredients),
              instructions: JSON.parse(foundRecipe.instructions),
            });
          }
        })
        .catch(error => console.error('Error fetching recipe:', error));
    }
  }, [id]);

  if (!recipe) {
    return <div className="container mt-5">Recipe not found.</div>;
  }

  return (
    <div className="container mt-5">
      <h1 className="mb-4">{recipe.name}</h1>
      <div className="card mb-4">
        <div className="card-body">
          <h6 className="card-subtitle mb-2 text-muted">Ingredients</h6>
          <ul>
            {recipe.ingredients.map((ingredient, index) => (
              <li key={index}>{ingredient}</li>
            ))}
          </ul>
          <h6 className="card-subtitle mb-2 text-muted">Instructions</h6>
          <ol>
            {recipe.instructions.map((instruction, index) => (
              <li key={index}>{instruction}</li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
};

export default RecipeDetail;